// Admin footer: centered copyright line in Horizon styling.
import { Flex, Text, useColorModeValue } from "@chakra-ui/react";

/**
 * Renders the admin footer with the current-year copyright notice.
 * @returns {React.ReactElement}
 */
export default function Footer() {
  const textColor = useColorModeValue("gray.400", "white");
  const year = new Date().getFullYear();
  return (
    <Flex justify="center" align="center" px="20px" py="24px">
      <Text fontSize="sm" color={textColor} textAlign="center">
        © {year} KantoBiz — made by DigiWide
      </Text>
    </Flex>
  );
}
